import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <h1 className="hero-title">
        Your first AI companion<br/>for startup ideas
      </h1>
      <p className="hero-subtitle">
        It helps you organise your thoughts, run the numbers,<br/>and see if your idea is worth pursuing.
      </p>
    </section>
  );
};

export default Hero;